var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slider',{attrs:{"value":_vm.value,"tick-labels":_vm.ticksLabels,"ticks":"always","step":"1","min":"1","max":"5","color":"primary","tick-size":"4","dense":"","readonly":""}})}
var staticRenderFns = []

export { render, staticRenderFns }